import type { ISerialize } from '@/objects/ISerialize';

export class SignalrRankedTimeSubscribeParameters implements ISerialize {
    public EventID: number;

    public RaceContestantID: number | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { EventID?: number; RaceContestantID?: number | null }) {
        this.EventID = values.EventID ?? 0;

        this.RaceContestantID = values.RaceContestantID ?? null;
    }

    public serialize(): string {
        return (
            '{' + `"EventID": ${JSON.stringify(this.EventID)}` + ',' + `"RaceContestantID": ${JSON.stringify(this.RaceContestantID)}` + '}'
        );
    }

    /**
     * Creates an instance of SignalrRankedTimeSubscribeParameters from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { EventID?: number; RaceContestantID?: number | null }): SignalrRankedTimeSubscribeParameters {
        return new SignalrRankedTimeSubscribeParameters(values);
    }

    public static _FromServerJson(json: any): SignalrRankedTimeSubscribeParameters {
        return new SignalrRankedTimeSubscribeParameters({ EventID: json.EventID, RaceContestantID: json.RaceContestantID ?? null });
    }

    /**
     * Creates an instance of SignalrRankedTimeSubscribeParameters from another instance of SignalrRankedTimeSubscribeParameters.
     * @param other The SignalrRankedTimeSubscribeParameters you want to clone
     * @returns A cloned SignalrRankedTimeSubscribeParameters
     */
    public static FromOther(other: SignalrRankedTimeSubscribeParameters): SignalrRankedTimeSubscribeParameters {
        return SignalrRankedTimeSubscribeParameters._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SignalrRankedTimeSubscribeParameters.FromOther(this);
    }

    static NAME_OF_CLASS = 'SignalrRankedTimeSubscribeParameters';
}
